import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import AsyncComponentErrorHandler from 'framework-asset-preview-lib/internal/shared/components/AsyncComponentErrorHandler';
export default Loadable({
  loader: () => import( /* webpackChunkName: "generic-carousel-preview" */'./GenericCarouselPreview').then(mod => mod.default).catch(AsyncComponentErrorHandler('generic-carousel-preview')),
  LoadingComponent: () => null
});